(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["parallax-image-gallery"] && !Shopify.designMode) return;
  try {
    
// 等待页面加载完成
document.addEventListener('DOMContentLoaded', function() {
  // 确保GSAP和ScrollTrigger已加载
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.error('GSAP或ScrollTrigger未加载');
    return;
  }
  
  // 注册ScrollTrigger插件
  gsap.registerPlugin(ScrollTrigger);
  
  // 获取section元素
  const section = document.querySelector('.parallax-section');
  
  if (!section) return;
  
  // 初始化视差效果
  function initParallax() {
    // 获取所有图片行
    const rows = document.querySelectorAll('.parallax-row');
    
    if (rows.length === 0) return;
    
    // 计算section的高度（移除单位，只获取数值）
    const sectionHeight = parseFloat(section.style.height) || 
                         parseFloat(getComputedStyle(section).height) || 
                         500;
    
    // 清理之前的ScrollTrigger
    ScrollTrigger.getAll().forEach(trigger => {
      if (trigger.trigger === section) {
        trigger.kill();
      }
    });
    
    // 为每行创建动画
    rows.forEach((row, index) => {
      // 计算移动方向：第1行向左，第2行向右，第3行向左
      const direction = index % 2 === 0 ? -1 : 1;
      
      // 获取行内所有图片
      const images = row.querySelectorAll('.parallax-image');
      if (images.length === 0) return;
      
      const imageWidth = images[0].offsetWidth;
      const gap = parseInt(getComputedStyle(row).gap) || 8;
      const imagesPerRow = images.length;
      const totalRowWidth = (imageWidth + gap) * imagesPerRow;
      const viewportWidth = window.innerWidth;
      
      // 计算需要移动的距离（大约是行宽的一半）
      const moveDistance = totalRowWidth / 2;
      
      // 重置行位置
      gsap.set(row, { x: 0 });
      
      // 为每行创建独立的ScrollTrigger
      const animation = gsap.fromTo(row, 
        { x: direction === -1 ? moveDistance * 0.2 : -moveDistance * 0.2 },
        { 
          x: direction * moveDistance,
          ease: "none"
        }
      );
      
      // 创建ScrollTrigger
      ScrollTrigger.create({
        animation: animation,
        trigger: section,
        start: "top 80%", // 当section顶部到达视口80%时开始
        end: "bottom 20%", // 当section底部到达视口20%时结束
        scrub: 2, // 稍微平滑的滚动
        markers: false, // 开发时可设为true查看触发点
        invalidateOnRefresh: true, // 刷新时重新计算
        onEnter: () => {
          section.classList.add('active');
        },
        onLeave: () => {
          section.classList.remove('active');
        },
        onEnterBack: () => {
          section.classList.add('active');
        },
        onLeaveBack: () => {
          section.classList.remove('active');
        }
      });
    });
    
    // 刷新ScrollTrigger以确保正确计算
    ScrollTrigger.refresh();
  }
  
  // 等待所有图片加载完成
  const images = section.querySelectorAll('img');
  let loadedImages = 0;
  
  function checkAllImagesLoaded() {
    loadedImages++;
    if (loadedImages === images.length) {
      setTimeout(initParallax, 100);
    }
  }
  
  if (images.length === 0) {
    setTimeout(initParallax, 100);
    return;
  }
  
  images.forEach(img => {
    if (img.complete) {
      checkAllImagesLoaded();
    } else {
      img.addEventListener('load', checkAllImagesLoaded);
      img.addEventListener('error', checkAllImagesLoaded);
    }
  });
  
  // 如果所有图片已经加载完成
  if (loadedImages === images.length) {
    setTimeout(initParallax, 100);
  }
  
  // 窗口大小变化时重新初始化
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      initParallax();
    }, 250);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-manual"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const categorymap= {
      vacuum: 'Vacuum',
      hold: 'Hold',
      mower: 'Mower',
      swbot: 'Swbot',
      cleaner: 'Cleaner',
      hairedryer: 'Hairedryer',
      feeder: 'Feeder',
      waterpuri: 'WaterPuri',
      toothbrush: 'Toothbrush'
    }
    let listData = [];
    // 生成 UUID
    function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    
    // AES 加密函数
    function aesEncrypt(plainText, key) {
        const encrypted = CryptoJS.AES.encrypt(plainText, key);
        return encrypted.toString();
    }
    
    // 生成请求所需的 g 和 i 参数
    function generateRequestParams() {
        const g = generateUUID();
        const timestamp = Math.floor(Date.now() / 1000); // 获取秒级时间戳
        const key = "TUOPiiZyt#z6%DKP";
        const textToEncrypt = `${g}_${timestamp}`;
        const i = aesEncrypt(textToEncrypt, key);
        return { g, i };
    }
    
    // 发起请求
    async function makeRequest() {
        // const url = 'https://cn-uat.iot.dreame.tech:30981/api/dreame-product/public/product/info'; // 测试环境1
        // const url = 'https://cn-uat.iot.dreame.tech/dreame-product/public/product/info'; // 测试环境2
        const url = 'https://global-prd.mova-tech.com/api/dreame-product/public/product/info'; // 生产环境
        const Authorization = 'Basic c2hvcGlmeV9zZzpFRVRqc3p1KlhJNXpuZGtsZHN1cQ==';
        const { g, i } = generateRequestParams();
    
        const headers = {
            Authorization,
            i,
            g,
            'Content-Type': 'application/json'
        };
    
        const body = JSON.stringify({
            "brand": "mova"
        });
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers,
                body
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const data = await response.json();
            if(data.success && data.code === 0) {
              // console.log('Response data:', data.data);
              fetchAndConvertToJson(data.data)
                .then(json => {
                  if (json) {
                    // console.log('转换后的 JSON:');
                    listData = json
                    renderUserManualCard(listData);
                  }
                });
            }
        } catch (error) {
            console.error('Fetch error:', error);
            listData = fakeUserManulData
        } finally {
          renderUserManualCard(listData);
        }
    }
    async function fetchAndConvertToJson(url) {
      try {
        const response = await fetch(url, {
          cache: 'no-cache' // 确保获取最新版本
        });
    
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const textData = await response.text();
        return JSON.parse(textData);
        // 下面的先不用
        // 假设 TXT 文件内容格式为键值对（例如：key=value）
        const lines = textData.split('\n');
        const result = {};
    
        for (const line of lines) {
          // 跳过空行和注释行（根据实际情况调整）
          if (!line.trim() || line.startsWith('#')) continue;
    
          // 分割键值对（这里用第一个等号分割）
          const [key, ...values] = line.split('=');
          const value = values.join('=').trim();
    
          // 自动转换数字类型
          result[key.trim()] = isNaN(value) ? value : Number(value);
        }
    
        // 转换为 JSON 字符串
        const jsonData = JSON.stringify(result, null, 2);
        return jsonData;
    
      } catch (error) {
        console.error('Error fetching data:', error);
        return null;
      }
    }
    function renderUserManualCard(datalist) {
      const wrapper = document.querySelector('.user-manual-wrapper');
      const returnDom = (data) => {
        let linksStr = '';
        const keys = Object.keys(data.faqs);
        if(keys.length > 0) {
          for(let key in data.faqs) {
            linksStr += `<a href="${data.faqs[key]}" target="_blank">${key}</a>`
          }
        }
        else {
          linksStr = `<a href="###" style="text-decoration: none;cursor: default;">-</a>`
        }
        return `
          <div class="manual-card">
            <div class="top">
              <img src="${data.mainImage}" alt="" width="" height="">
            </div>
            <div class="bottom">
              <span>${categorymap[data.categoryPath.split('/').reverse()[0]]}</span>
              <p class="m-sub-title">${data.localizationDisplayNames.en}</p>
              <p class="small-title">LANGUAGE</p>
              <div class="links">${linksStr}</div>
            </div>
          </div>
        `
      }
      let html = ''
      datalist.forEach(data => {
        html += returnDom(data);
        wrapper.innerHTML = html;
      })
    } 
    // 调用请求函数
    makeRequest();
  })

  } catch(e) { console.error(e); }
})();
})();
